import {
  MockMap,
} from '@ama-sdk/core';
import {
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  CheckInFlightIdObjectRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  combineCheckInFlightIdObjects,
  combineJourneyElementCommons,
  combineJourneys,
  combineJourneyTravelers,
  ContextualSeatmapDataRepository,
  createAcceptance,
  createJourney,
  createJourneyElement,
  createMockData,
  createMockDataWithResponse,
  JourneyTravelerRepository,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';

const journey = createJourney({
  template: {
    type: 'standalone',
    travelers: combineJourneyTravelers([
      JourneyTravelerRepository.MAN,
      JourneyTravelerRepository.WOMAN,
      JourneyTravelerRepository.CHD,
      JourneyTravelerRepository.MAN]).items,
    flights: combineCheckInFlightIdObjects([
      CheckInFlightIdObjectRepository.FRA_NCE]).items,
    journeyElements: combineJourneyElementCommons([
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-0-MOCK'
          }
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-1-MOCK'
          }
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-2-MOCK'
          }
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-3-MOCK'
          }
        }
      }]).items,
    acceptance: {
      isAccepted: false,
      isPartial: false
    }
  }
});

const partialAcceptedjourney = createJourney({
  template: {
    ...journey,
    journeyElements: combineJourneyElementCommons([
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-0-MOCK'
          },
          checkInStatus: 'accepted'
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-1-MOCK'
          },
          checkInStatus: 'accepted'
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-2-MOCK'
          },
          checkInStatus: 'notAccepted'
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-3-MOCK'
          },
          checkInStatus: 'notAccepted'
        }
      }
    ]).items,
    acceptance: createAcceptance({
      template: {
        checkedInJourneyElements: [
          {
            id: 'JOURNEY-ELEMENT-0-MOCK',
            journeyElement: createJourneyElement()
          },
          {
            id: 'JOURNEY-ELEMENT-1-MOCK',
            journeyElement: createJourneyElement()
          }
        ],
        notCheckedInJourneyElements: [
          {
            id: 'JOURNEY-ELEMENT-3-MOCK',
            journeyElement: createJourneyElement()
          },
          {
            id: 'JOURNEY-ELEMENT-4-MOCK',
            journeyElement: createJourneyElement()
          }
        ],
        isAccepted: false,
        isPartial: true
      }
    })
  }
});

const secondpartialAcceptedjourney = createJourney({
  template: {
    ...journey,
    journeyElements: combineJourneyElementCommons([
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-0-MOCK'
          },
          checkInStatus: 'accepted'
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-1-MOCK'
          },
          checkInStatus: 'accepted'
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-2-MOCK'
          },
          checkInStatus: 'accepted'
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-3-MOCK'
          },
          checkInStatus: 'notAccepted'
        }
      }
    ]).items,
    acceptance: createAcceptance({
      template: {
        checkedInJourneyElements: [
          {
            id: 'JOURNEY-ELEMENT-0-MOCK',
            journeyElement: createJourneyElement()
          },
          {
            id: 'JOURNEY-ELEMENT-1-MOCK',
            journeyElement: createJourneyElement()
          },
          {
            id: 'JOURNEY-ELEMENT-3-MOCK',
            journeyElement: createJourneyElement()
          }
        ],
        notCheckedInJourneyElements: [
          {
            id: 'JOURNEY-ELEMENT-4-MOCK',
            journeyElement: createJourneyElement()
          }
        ],
        isAccepted: false,
        isPartial: true
      }
    })
  }
});

const notAcceptedJourneyAfterDeletePax = createJourney({
  template: {
    ...journey,
    journeyElements: combineJourneyElementCommons([
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-0-MOCK'
          },
          flightId: 'CHECK-IN-FLIGHT-0-MOCK'
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-1-MOCK'
          },
          flightId: 'CHECK-IN-FLIGHT-0-MOCK'
        }
      }]).items
  }
});

const notAcceptedJourneyAfterSecondDeletePax = createJourney({
  template: {
    ...journey,
    journeyElements: combineJourneyElementCommons([
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-2-MOCK'
          },
          flightId: 'CHECK-IN-FLIGHT-0-MOCK'
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-3-MOCK'
          },
          flightId: 'CHECK-IN-FLIGHT-0-MOCK'
        }
      }]).items
  }
});

const acceptedJourneyAfterDeletePax = createJourney({
  template: {
    ...journey,
    travelers: combineJourneyTravelers([
      JourneyTravelerRepository.MAN,
      JourneyTravelerRepository.WOMAN]).items,
    journeyElements: combineJourneyElementCommons([{
      journeyElement: {
        traveler: {
          id: 'JOURNEY-TRAVELER-0-MOCK'
        },
        flightId: 'CHECK-IN-FLIGHT-0-MOCK',
        checkInStatus: 'accepted'
      }
    },
    {
      journeyElement: {
        traveler: {
          id: 'JOURNEY-TRAVELER-1-MOCK'
        },
        flightId: 'CHECK-IN-FLIGHT-0-MOCK',
        checkInStatus: 'accepted'
      }
    }]).items,
    acceptance: {
      isAccepted: true,
      isPartial: false
    }
  }
});

const acceptedJourneyAfterSecondDeletePax = createJourney({
  template: {
    ...journey,
    travelers: combineJourneyTravelers([
      JourneyTravelerRepository.CHD]).items,
    journeyElements: combineJourneyElementCommons([{
      journeyElement: {
        traveler: {
          id: 'JOURNEY-TRAVELER-2-MOCK'
        },
        flightId: 'CHECK-IN-FLIGHT-0-MOCK',
        checkInStatus: 'accepted'
      }
    }]).items,
    acceptance: {
      isAccepted: true,
      isPartial: false
    }
  }
});

const allAcceptedJourney = createJourney({
  template: {
    ...journey,
    journeyElements: combineJourneyElementCommons([
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-0-MOCK'
          },
          checkInStatus: 'accepted'
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-1-MOCK'
          },
          checkInStatus: 'accepted'
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-2-MOCK'
          },
          checkInStatus: 'accepted'
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-3-MOCK'
          },
          checkInStatus: 'accepted'
        }
      }]).items,
    acceptance: createAcceptance({
      template: {
        isAccepted: true,
        isPartial: false
      }
    })
  }
});

const journeyElementIds = journey.journeyElements.map((je: JourneyElementCommon) => je.id);
/**
 * OW 1 Journey
 * Check-in 3ADT 1CHD Partial Checkin Seperately
 * No baggage
 */
export const ow1Journey3Adt1ChdPartialCheckin: MockMap = {
  generateBoardingPasses: [createMockDataWithResponse(combineBoardingPassResults(undefined, {
    journeyElementIds
  }).items, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [{
    code: '10000',
    title: 'No unpaid service',
    type: 'error',
    id: '10000'
  }])],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201),
    createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201),
    createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201),
    createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)
  ],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [
    createMockDataWithResponse(combineJourneys([journey]).items, 201),
    createMockDataWithResponse(combineJourneys([partialAcceptedjourney]).items, 201),
    createMockDataWithResponse(combineJourneys([secondpartialAcceptedjourney]).items, 201),
    createMockDataWithResponse(combineJourneys([allAcceptedJourney]).items, 201)],
  retrieveJourney: [
    createMockData(notAcceptedJourneyAfterDeletePax),
    createMockData(acceptedJourneyAfterDeletePax),
    createMockData(notAcceptedJourneyAfterSecondDeletePax),
    createMockData(acceptedJourneyAfterSecondDeletePax),
    createMockData(allAcceptedJourney)
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(ContextualSeatmapDataRepository.DEFAULT)],
  removeTravelersFromJourney: [createMockData({})]
};
